(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets-claim/assets/init.js') >= 0) return;  svs.modules.push('/modules/tickets-claim/assets/init.js');
"use strict";

var _svs$utils$paramHandl;
const container = document.getElementById('reactContainer');
const _svs$tur = svs.tur,
  VoucherRedeem = _svs$tur.VoucherRedeem,
  NeedHelp = _svs$tur.NeedHelp;
const branding = svs.core.template.data.templateConfig.branding;
const voucherParam = (_svs$utils$paramHandl = svs.utils.paramHandler.get({
  key: 'voucherCode'
})) === null || _svs$utils$paramHandl === void 0 ? void 0 : _svs$utils$paramHandl.value;
const _svs$ui$ReactGrid = svs.ui.ReactGrid,
  Grid = _svs$ui$ReactGrid.Grid,
  GridCol = _svs$ui$ReactGrid.GridCol,
  GridRow = _svs$ui$ReactGrid.GridRow;
const handleCancel = e => {
  e && e.preventDefault();
  const to = branding.includes('triss') ? svs.core.urlMapping.get('trissHome') : svs.core.urlMapping.get('skrapspelHome');
  svs.utils.url.navigate("".concat(window.location.origin, "/").concat(to));
};
const handleSuccess = voucherCode => {
  svs.utils.url.navigate("".concat(svs.core.urlMapping.get('ticketGiftHome'), "/").concat(voucherCode, "?manual=true"));
};
if (voucherParam) {
  svs.utils.paramHandler.remove({
    key: 'voucherCode'
  });
}
container && ReactDOM.render(React.createElement(Grid, null, React.createElement(GridRow, {
  className: "u-flex-justify-content-center padding-2"
}, React.createElement(GridCol, {
  am: 8,
  lg: 4,
  sm: 12
}, React.createElement(VoucherRedeem, {
  onCancel: handleCancel,
  onSuccess: handleSuccess,
  shouldFetch: true,
  voucherId: voucherParam
}), React.createElement("div", {
  className: "margin-top-2"
}, React.createElement(NeedHelp, null))))), container);

 })(window);